// @ts-check

import React, { useRef } from 'react';
import moment from 'moment';

import Button from 'infrastructure/js/components/controls/Button/button';
import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper.js';

import WeekPicker from './weekPicker';
import WeekPickerOverlay from './weekPickerOverlay';



/**
 * @param {{
 *   onDateSelected?: (m: moment.Moment | null) => void
 *   momentDate?: moment.Moment | null
 * }} props
 * 
 */
export default function WeekPickerPopover(props) {

  // Chosen Date state is passed down to the WeekPickerOverlay component from redux.
  // let [selectedDate, setSelectedDate] = useState(/** @type {moment.Moment | null} */(props.momentDate || moment(new Date())));


  let refOverlayAnchorTarget = useRef(null);
  const refOverlayForward = useRef(null);


  /** 
   * @param {moment.Moment | null} momentNoZone
   * 
   */
  let onDateSelected = (momentNoZone) => {

    // setSelectedDate(momentNoZone);
    
    // let momentWeekStart = momentNoZone?.clone().startOf("isoWeek") || null;
    let momentWeekStart = momentNoZone && moment(
      DateTimeHelper.transformDateToStartOfWeekAuto(
        momentNoZone.clone().utcOffset(0, true).toDate()
      )
    );
    
    // @ts-ignore
    refOverlayForward.current?.close()

    if (props.onDateSelected) {
      props.onDateSelected(momentWeekStart);
    }

  };


  return (

    <>

      <div ref={refOverlayAnchorTarget} className="week-nav-button">
        <Button
          id="chooseWeek"
          name="chooseWeek"
          className={'border-btn only-icon'}
          // @ts-ignore
          onClick={() => { refOverlayForward.current?.toggle(); }}
        />
      </div>

      <WeekPickerOverlay
        refOverlayTarget={refOverlayAnchorTarget}
        ref={refOverlayForward}
      >
        <WeekPicker
          // selectedDate={selectedDate}
          selectedDate={props.momentDate || moment(new Date())}
          onChange={onDateSelected}
        />
      </WeekPickerOverlay>



    </>
  );

}





